import * as React from "react";
import { Book } from "../../../../../types/Book";
import Button from "../../../../Button/Button";
import "./Inner.css";
import { useMediaQuery } from "react-responsive";
import Close from "@material-ui/icons/Close";
import { FeedCallbacksContext } from "../../../Feed";
import BookDialogPreview from "../../../../BookDialogPreview/BookDialogPreview";
import cn from "classnames";
import { CardsManagerCallbacks } from "../../../../CardsManager/CardsManager";
import UserList from "../../../../BookPage/UserList/UserList";
import BookShop from "./BookShop/BookShop";
import { MOBILE_MAX_WIDTH } from "../../../../../utils";

interface Props {
	book: Book;
	onClose?: () => void;
	className?: string;
	callbacks?: CardsManagerCallbacks;
}

const Inner: React.FC<Props> = ({
	book,
	onClose,
	className,
	callbacks: context,
}) => {
	// const context = React.useContext(FeedCallbacksContext);

	const [show, setShow] = React.useState(false);

	const onClick = () => {
		if (book.card) {
			window.location.href = `/books/#/${book.card.id}`;
		} else {
			setShow(true);
		}
	};

	const descWrapperRef = React.useRef<HTMLDivElement>();
	const showMoreRef = React.useRef<HTMLDivElement>();

	const showDesc = (e: any) => {
		if (descWrapperRef) {
			descWrapperRef.current.classList.add(
				"feed-dialog-inner-book-header__description__wrapper_full"
			);

			showMoreRef.current.style.display = "none";
		}
	};

	React.useEffect(() => {
		if (descWrapperRef) {
			descWrapperRef.current.classList.remove(
				"feed-dialog-inner-book-header__description__wrapper_full"
			);

			const height = descWrapperRef.current.offsetHeight;
			const childHeight = (descWrapperRef.current.firstChild as HTMLDivElement)
				.offsetHeight;

			console.log(childHeight, height);

			if (childHeight > height) {
				showMoreRef.current.style.display = "block";
			} else {
				descWrapperRef.current.classList.add(
					"feed-dialog-inner-book-header__description__wrapper_full"
				);

				showMoreRef.current.style.display = "none";
			}
		}
	}, [book]);

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });

	return (
		<div className={className}>
			{true && (
				<div className="feed-dialog-close">
					О книге
					{onClose && (
						<div className="feed-dialog-close__button" onClick={onClose}>
							<Close />
						</div>
					)}
				</div>
			)}

			<div className="feed-dialog-inner">
				<div className="feed-dialog-inner__left">
					<div className="feed-dialog-inner__background">
						<div
							className="feed-dialog-inner__background__big"
							style={{ backgroundImage: `url(${book.image})` }}
						/>

						<div
							className="feed-dialog-inner__background__img"
							style={{ backgroundImage: `url(${book.image})` }}
						/>
					</div>

					{book.shops?.length > 0 && !isMobile && <BookShop shop={book.shops} />}
				</div>

				<div className="feed-dialog-inner-book">
					<div className="feed-dialog-inner-book-header">
						<div className="feed-dialog-inner-book-header__payload">
							<div className="feed-dialog-inner-book-header__author">
								{book.author}
							</div>

							<div className="feed-dialog-inner-book-header__name">
								{book.name}
							</div>
						</div>

						<Button
							type="primary"
							className="feed-dialog-inner-book-header__add"
							onClick={onClick}
						>
							{book.card ? "Открыть карточку" : "Сохранить в моей библиотеке"}
						</Button>
					</div>

					<div className="feed-dialog-inner-book-description">
						<div
							className="feed-dialog-inner-book-header__description__wrapper"
							ref={descWrapperRef}
						>
							<div
								className="feed-dialog-inner-book-header__description"
								dangerouslySetInnerHTML={{
									__html: book.description,
								}}
							></div>
						</div>

						<div
							className="feed-dialog-inner-book-header__description__more"
							onClick={showDesc}
							ref={showMoreRef}
						>
							Читать далее
						</div>
					</div>

					{book.shops?.length > 0 && isMobile && <BookShop shop={book.shops} />}

					<UserList book={book} />

					{book.collection && (
						<div className="feed-dialog-inner-collection">
							<a
								className="feed-dialog-inner-collection__name"
								href={`/list/category-${book.collection.id}`}
							>
								{book.collection.image && (
									<div
										className="feed-dialog-inner-collection__image"
										style={{ backgroundImage: `url(${book.collection.image})` }}
									/>
								)}

								{book.collection.name}
							</a>
						</div>
					)}
				</div>
			</div>

			{show && (
				<BookDialogPreview
					bookExternalId={book.externalId}
					bookWooId={book.woo_id}
					saveCard={context.addCard}
					saveProperties={context.saveCardProperties}
					onClose={() => setShow(false)}
					onSaved={() => setShow(false)}
				/>
			)}
		</div>
	);
};

export default Inner;
